import { addAircraftType, deleteAircraftType, editAircraftType } from "./actions";

export const flightHours = {
    "label": "Flight Hours",
    "key": "NewFlightHours",
    "local": true,
    "headers": [{
        "headerName": "CS Type",
        "field": "CS"
    }, {
        "headerName": "Aircraft Type",
        "field": "Type"
    }, {
        "headerName": "Total Flight Hours",
        "field": "Hours"
    }, {
        "headerName": "Total Test Hours",
        "field": "Test"
    }, {
        "headerName": "Total PIC Hours (Last 12 Months)",
        "field": "FlightHoursPIC"
    }, {
        "headerName": "Total CO Hours (Last 12 Months)",
        "field": "FlightHoursCO"
    }, {
        "headerName": "Total PIC Test Hours (Last 12 Months)",
        "field": "FlightHoursPICTest"
    }, {
        "headerName": "Total CO Test Hours (Last 12 Months)",
        "field": "FlightHoursCOTest"
    }, {
        "headerName": "Last Updated",
        "field": "LastUpdated",
        "type": "date"
    }],
    "actions": [{
        "label": "Add Aircraft Type",
        "action": addAircraftType
    }],
    "rowActions": [{
        "label": "Edit",
        "action": editAircraftType
    }, {
        "label": "Delete",
        "action": deleteAircraftType,
        "break": true,
        "class": "text-red"
    }],
    warn({ items }) {
        let warnText = "";

        for (const item of items) {

            let total = parseFloat(item.Hours);
            
            let last12Total = 
                parseFloat(item.FlightHoursPIC) + 
                parseFloat(item.FlightHoursCO) + 
                parseFloat(item.FlightHoursPICTest) + 
                parseFloat(item.FlightHoursCOTest);

            if (item.Test > total) {
                warnText += `The total test hours for ${item.Type} is greater than the total flight hours.\n`;
            };

            if (last12Total > total) {
                warnText += `The total PIC and CO hours for ${item.Type} is greater than the total flight hours.\n`;
            };
        };

        return [warnText !== "", warnText];
    }
};
